import { render } from "./Author.vue?vue&type=template&id=579e770e"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"

import "./Author.vue?vue&type=style&index=0&id=579e770e&scope=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__